import checkapplye from '@/view/check-apply-evaluate';

const checke = {
    install:function (Vue) {
        Vue.component('checke',checkapplye)
    }
}
export default checke;